import { ExternalLink, Headline, HtmlContainer } from '../../ui';
import { N2ApplicationStatus } from '../../serverGeneratedTypings/n2ApplicationStatus';
import { ApplicationStatusPage, CommonStatusPageProps } from '../../components/ApplicationStatusPage';

import style from './style.module.scss';
import { useTranslation } from 'react-i18next';
import { useApplicationIdContext } from '@n2-common/components/ApplicationContext';

const DeclinedWithLinkPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {
    
     const { t } = useTranslation('common');

     const { country } = useApplicationIdContext(false);
     const linkKey = getLinkKey (country);

    return (
        <ApplicationStatusPage
            navigateToCorrectStepFunc={navigateToCorrectStepFunc}
            correctStateFunc={(res) => res.Status === N2ApplicationStatus.Declined}
        >
            <Headline>{t<string>('ApplicationLandingPages.DeclinedWithLink.Headline')} </Headline>

            <HtmlContainer innerHtml={t<string>('ApplicationLandingPages.DeclinedWithLink.DescriptionHtml')} />

            <ExternalLink linkKey={linkKey} rel="noopener noreferrer" target="_blank" className={style.underlined}>
                        {t<string>('ApplicationLandingPages.DeclinedWithLink.LinkText')}
             </ExternalLink>
        </ApplicationStatusPage>
    );
};

export function getLinkKey (country: Country )  {
    switch(country) {
        case 'SE': return "DECLINED_AFFILIATE_LINK.SE";
        case 'FI': return "DECLINED_AFFILIATE_LINK.FI";
        case 'NO': return "DECLINED_AFFILIATE_LINK.NO";
    }
}

export default DeclinedWithLinkPage;
